





























import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import { FilterPassBadge } from "@/utils/filterPassBadges";
import CdkFilterPassBadge from "./CdkFilterPassBadge.vue"; // eslint-disable-line no-unused-vars

@Component({
  components: {
    CdkFilterPassBadge
  }
})
export default class CdkFilterPassBadges extends Vue {
  @Prop({
    type: Array,
    required: true
  })
  filterPassBadges!: FilterPassBadge[];

  @Prop({
    type: Boolean,
    default: false
  })
  isPreview?: boolean;

  get hasPublicPassBadges(): boolean {
    return this.filterPassBadges.some(({ isPublic }) => isPublic);
  }

  isCompact(index: number): boolean {
    return this.isPreview || (!this.hasPublicPassBadges && index > 0);
  }
}
